import React, { useEffect } from 'react';
import styled from 'styled-components';
import StorySlide from './StorySlide';
import { breakpoints } from '../../utils/styles';
import { fetchYearRecap } from '../../actions/creators/yearRecap';

const Container = styled.div`
    left: 0;
    position: fixed;
    top: 0;
    z-index: 100000;
}`;

const BlackBg = styled.div`
    background: rgba(0, 0, 0, 0.9);
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
`;

const TopButtons = styled.div`
    color: white;
    cursor: pointer;
    font-size: 1.5rem;
    position: fixed;
    right: 16px;
    top: 26px;
    z-index: 100001;

    @media (min-width: ${breakpoints.desktop}px) {
        top: 10px;
    }

    & > i {
        margin-left: 1rem;
    }
`;

export interface SlideProps {
    current?: boolean;
    scale?: number;
}

export interface Props {
    data: any | null;
    slides: React.FC<SlideProps>[];
    onClose: () => void;
}

const Story: React.FC<Props> = ({ data, slides, onClose }) => {
    const slideDuration = 8000; // 8 seconds per slide
    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [timerStartTime, setTimerStartTime] = React.useState<number | null>(null);
    const [timerRemaining, setTimerRemaining] = React.useState(slideDuration);
    const [paused, setPaused] = React.useState<boolean | null>(null);
    const [soundEnabled, setSoundEnabled] = React.useState(false);
    const [timer, setTimer] = React.useState<ReturnType<typeof setTimeout> | null>(null);

    function setNext() {
        setCurrentSlide((prev) => Math.min(prev + 1, slides.length - 1));
    }

    function setPrev() {
        setCurrentSlide((prev) => Math.max(prev - 1, 0));
    }

    useEffect(() => {
        fetchYearRecap();
    }, [fetchYearRecap]);

    useEffect(() => {
        if (currentSlide < slides.length - 1) {
            timer && clearTimeout(timer);
            const t = setTimeout(setNext, slideDuration);
            setTimer(t);
            setTimerStartTime(Date.now());
            setTimerRemaining(slideDuration);
            setPaused(null);
            return () => { timer && clearTimeout(timer); }
        }
    }, [currentSlide]);

    useEffect(() => {
        if (null === paused) return;

        if (paused) {
            timer && clearTimeout(timer);
            setTimerRemaining((prev) => prev - (Date.now() - (timerStartTime || 0)));
        } else {
            const t = setTimeout(setNext, timerRemaining);
            setTimer(t);
            setTimerStartTime(Date.now());
        }
    }, [paused]);

    return (
        <Container>
            <BlackBg />
            <TopButtons>
                <i className={`fal fa-volume${soundEnabled ? '' : '-slash'}`} onClick={() => setSoundEnabled(!soundEnabled)}></i>
                <i className={`fal fa-${paused ? 'play' : 'pause'}`} onClick={() => setPaused(!paused)}></i>
                <i className="fal fa-times" onClick={onClose}></i>
            </TopButtons>
            {slides.map((SlideComponent, index) => (
                <StorySlide
                    key={index}
                    current={index === currentSlide}
                    data={data}
                    prev={index < currentSlide}
                    next={index > currentSlide}
                    onNext={setNext}
                    onPrev={setPrev}
                    onClick={() => setCurrentSlide(index)}
                    // onMouseDown={() => setPaused(true)}
                    // onMouseUp={() => setPaused(false)}
                    Content={SlideComponent}
                    total={slides.length}
                    index={index}
                    paused={paused || false}
                    soundEnabled={soundEnabled}
                    zIndex={slides.length - index}
                />
            ))}
        </Container>
    );
};

export default Story;